export default __webpack_public_path__ + "static/media/smaller_headshot.48f8e24d.png";